import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginatedResponse, PaginationParams } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

import type { AuditLogItem, EntityHistoryItem } from "./types";

export const auditLogApi = {
  async getAuditLogs(
    params?: PaginationParams
  ): Promise<PaginatedResponse<AuditLogItem>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, "/audit-log", params);
    return apiClient.get<PaginatedResponse<AuditLogItem>>(url);
  },

  async getEntityHistory(
    entityId: string,
    params?: PaginationParams
  ): Promise<PaginatedResponse<EntityHistoryItem>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, `/audit-log/${entityId}`, params);

    return apiClient.get<PaginatedResponse<EntityHistoryItem>>(url);
  },

  async getEntityHistoryByType(
    entityType: string,
    params?: PaginationParams
  ): Promise<PaginatedResponse<EntityHistoryItem>> {
    const url = buildUrl(
      API_ENDPOINTS.ADMIN,
      `/audit-log/by-type/${entityType}`,
      params
    );

    return apiClient.get<PaginatedResponse<EntityHistoryItem>>(url);
  },
};
